import NewCarouselImages from '@/core/components/NewCarouselImages/NewCarouselImages';

export default NewCarouselImages;
